export default "__VITE_ASSET__DQKaxBf2__"